import React, { useEffect, useState } from "react";
import { Container, Table, Button, Spinner, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

export default function BonTransferList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const fetchList = async () => {
    try {
      const data = await authFetch("/bon_transfer/");
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.items)
          ? data.items
          : [];
      setRows(items);
    } catch (e) {
      setErr(e?.message || String(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Sigur doriți să ștergeți acest transfer?")) {
      return;
    }
    try {
      await authFetch(`/bon_transfer/${id}`, {
        method: "DELETE",
      });
      fetchList();
    } catch (e) {
      alert(`Eroare la ștergere: ${e.message || e}`);
    }
  };

  if (loading) {
    return (
      <Container className="py-3">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Bonuri transfer</h3>
        <Button as={Link} to="/bon-transfer/create">
          + Adaugă
        </Button>
      </div>

      {err && <Alert variant="danger">{err}</Alert>}

      <Table bordered hover size="sm" responsive>
        <thead>
          <tr>
            <th style={{ width: 80 }}>ID</th>
            <th style={{ width: 140 }}>Nr</th>
            <th style={{ width: 160 }}>Data</th>
            <th style={{ width: 140 }}>Gestiune</th>
            <th style={{ width: 140 }}>Gestiune 2</th>
            <th>Beneficiar</th>
            <th style={{ width: 180 }}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.bxdoc_no ?? ""}</td>
              <td>{r.bxdoc_date ?? ""}</td>
              <td>{r.bxgestiune_id ?? ""}</td>
              <td>{r.bxgestiune2_id ?? ""}</td>
              <td>
                {r.contact_name || r.contact?.bxdenumire || "—"}
              </td>
              <td className="text-end">
                <Button
                  as={Link}
                  to={`/bon-transfer/${r.id}`}
                  size="sm"
                  variant="outline-primary"
                  className="me-2"
                >
                  Deschide
                </Button>
                <Button
                  size="sm"
                  variant="outline-danger"
                  disabled={r.bxfinal_bool === 1}
                  onClick={() => handleDelete(r.id)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}

          {rows.length === 0 && (
            <tr>
              <td colSpan={7} className="text-center text-muted py-4">
                Nu există bonuri transfer.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}
